import React from 'react'

const LoadingIcon = () => (
  <div className="loading-icon">
    <div className="bounce1" />
    <div className="bounce2" />
    <div className="bounce3" />
  </div>
)

export default LoadingIcon



// WEBPACK FOOTER //
// ./src/Components/LoadingIcon.js